import { useCallback } from 'react';
import type { To } from 'react-router';
import type { NavigateOptions } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports
import { useNavigate } from 'react-router-dom';

export const useNavigateReplace = () => {
	const navigate = useNavigate();
	return useCallback((to: To, options?: NavigateOptions) => navigate(to, { ...options, replace: true }), [navigate]);
};
